import React from 'react';
import { l10n } from '@ott/l10n';

import { Container, Row, Col } from '@ott/grid';
import AppStore from '@ott/icon-appstore';
import GooglePlay from '@ott/icon-google-play';
import AppGallery from '@ott/icon-app-gallery';

import styles from './AppsSection.scss';
import QrCode from './blocks/QrCode';
import { AppLinks } from '../../Footer';

type Props = {
  appLinks: AppLinks;
};

const AppsSection = ({ appLinks: { android, ios, huawei } }: Props) => {
  return (
    <div className={styles.container}>
      <Container>
        <Row>
          <Col desktop={6} mobile={4}>
            <div className={styles.title}>{l10n('footer.mobileAppTitle')}</div>
            <div className={styles.appsContainer}>
              <a className={styles.appsLink} target="_blank" href={ios}>
                <AppStore />
              </a>
              <a className={styles.appsLink} target="_blank" href={android}>
                <GooglePlay />
              </a>
              {huawei && (
                <a className={styles.appsLink} target="_blank" href={huawei}>
                  <AppGallery />
                </a>
              )}
            </div>
          </Col>
          <Col desktop={6} mobile={0}>
            <div className={styles.qrCodeContainer}>
              <QrCode />
              <div>
                <div className={styles.title}>{l10n('footer.qrCodeTitle')}</div>
                <div className={styles.text}>{l10n('footer.qrCodeTip')}</div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default React.memo(AppsSection);
